import type {
  ConfigureRequest,
  ConfigureResponse,
  Fetch,
  FetchFunction,
  RequestConstructor,
} from './types';

export function configureFetch(
  fetch: Fetch,
  createRequest: RequestConstructor,
  {
    requestConfigurators,
    responseConfigurators,
  }: {
    requestConfigurators?: ConfigureRequest[];
    responseConfigurators?: ConfigureResponse[];
  }
): Fetch {
  const configuredFetch: FetchFunction = (input, init) => {
    let request = createRequest(input, init);

    if (requestConfigurators) {
      for (const configure of requestConfigurators) {
        request = configure(request);
      }
    }

    if (responseConfigurators?.length) {
      return fetch(request).then((response) => {
        for (const configure of responseConfigurators) {
          response = configure(response);
        }

        return response;
      });
    } else {
      return fetch(request);
    }
  };

  return Object.assign(configuredFetch, fetch);
}
